import {Stack, TextField, Typography} from '@mui/material';

/** Hours and minutes for a duration kept in minutes; blank is "not recorded". */
export function MinutesField({label, value, onChange, disabled, testId, helper}: {
  label: string; value: number | null; onChange: (minutes: number | null) => void; disabled?: boolean; testId?: string; helper?: string;
}) {
  const hours = value === null ? '' : String(Math.floor(value / 60));
  const minutes = value === null ? '' : String(value % 60);
  const set = (h: string, m: string) => {
    if (h.trim() === '' && m.trim() === '') {
      onChange(null);
      return;
    }
    const hv = h.trim() === '' ? 0 : Number(h);
    const mv = m.trim() === '' ? 0 : Number(m);
    if (!Number.isInteger(hv) || !Number.isInteger(mv) || hv < 0 || mv < 0) return;
    onChange(hv * 60 + mv);
  };
  return (
    <Stack spacing={0.5} data-review-field={testId}>
      <Typography variant="subtitle2">{label}</Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        <TextField size="small" label="Hours" value={hours} sx={{width: 90}} disabled={disabled}
                   inputProps={{inputMode: 'numeric', 'data-testid': testId ? `${testId}-hours` : undefined}}
                   onChange={event => set(event.target.value, minutes)}/>
        <TextField size="small" label="Minutes" value={minutes} sx={{width: 90}} disabled={disabled}
                   inputProps={{inputMode: 'numeric'}}
                   onChange={event => set(hours, event.target.value)}/>
        {value === null && <Typography variant="caption" color="text.secondary">Not recorded</Typography>}
      </Stack>
      {helper && <Typography variant="caption" color="text.secondary">{helper}</Typography>}
    </Stack>
  );
}

export const formatMinutes = (minutes: number | null | undefined) => {
  if (minutes === null || minutes === undefined) return '';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return h > 0 ? `${h} h ${m} min` : `${m} min`;
};

export const money = (value: number | null | undefined) =>
  value === null || value === undefined ? '' : new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(value);
